/**
 * Token de inyección para ProductRepository
 */

import { InjectionToken } from '@angular/core';
import { ProductRepository } from './product.repository';

export const PRODUCT_REPOSITORY_TOKEN = new InjectionToken<ProductRepository>('ProductRepository');

